import { render, staticRenderFns } from "./SurveysList.vue?vue&type=template&id=1b9bd41c&"
import script from "./SurveysList.vue?vue&type=script&lang=js&"
export * from "./SurveysList.vue?vue&type=script&lang=js&"
import style0 from "./SurveysList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports